import { render, staticRenderFns } from "./HarcMasrafOdeIslemDetayView.vue?vue&type=template&id=b0545da6&scoped=true"
import script from "./HarcMasrafOdeIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./HarcMasrafOdeIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0545da6",
  null
  
)

export default component.exports